import React from 'react';

const ROLE_LABELS = {
  lab_manager: 'Lab Manager',
  operations_manager: 'Operations Manager',
  finance: 'Finance',
};

export const negotiatorLabels = (roles = []) => roles.map((r) => ROLE_LABELS[r] || r).join(', ');

export const NegotiationBadge = ({ quot }) => {
  if (!quot || !quot.negotiation_status || quot.negotiation_status === 'none') return null;

  if (quot.negotiation_status === 'under_negotiation') {
    return (
      <span
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-amber-100 text-amber-800 border border-amber-300"
        data-testid={`negotiation-badge-${quot.id}`}
        title={`Negotiating: ${negotiatorLabels(quot.negotiators)}`}
      >
        Under negotiation · {negotiatorLabels(quot.negotiators)}
      </span>
    );
  }

  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-800 border border-emerald-300"
      data-testid={`negotiation-badge-${quot.id}`}
      title={`Negotiated by: ${negotiatorLabels(quot.negotiators)}`}
    >
      Negotiated · {negotiatorLabels(quot.negotiators)}
    </span>
  );
};

export default NegotiationBadge;
